<template>
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <model path="/static/ibis/ibisRatesHorizontalV2" :content="model" :format='1610'></model>
    <div id="ibisRatesHorizontalV2" class="">
      <div id="main_title">
        <div class="lg1">Prix des chambres</div>
        <div id="dot_separator">.......</div>
        <div id="date_hour">{{ date }}</div>
      </div>
      <div id="center">
        <div id="rates">
          <div id="header_row">
            <div id="rates_title"><span class="lg1">{{ ratesLg[currentLg].settings.rates_extratitle }}</span></div>
            <div id="rates_prices_titles">
              <div class="col_price"><span class="lg1">{{ replaceBr(ratesLg[currentLg].periodTitle.period1) }}</span></div>
              <div class="col_price"><span class="lg1">{{ replaceBr(ratesLg[currentLg].periodTitle.period2) }}</span></div>
            </div>
          </div>
          <div class="rates_row" v-for="(key, index) in Object.keys(ratesLg[currentLg].rates)" v-if="index < 3">
            <div class="rates_labels">
              <div class="rate_label lg1">
                {{ ratesLg[currentLg].rates[key][0].label_value }} {{ ratesLg[currentLg].rates[key][0].sub_label }}
              </div>
            </div>
            <div class="rates_prices">
              <div class="rate_price">{{ ratesLg[currentLg].rates[key][0].mrr_value }}</div>
              <div class="rate_price">{{ ratesLg[currentLg].rates[key][1].mrr_value }}</div>
            </div>
          </div>
        </div>
        <div id="services">
          <div id="services_regular">
            <div class="service" v-for="(service, index) in ratesLg[currentLg].otherServices.regular" v-if="index < 4 && service.is_additional_services === ''">
              <div class="services_labels">
                <div class="service_label lg1">
                  <span>{{ service.label_value }}</span> <span>{{ service.sub_label }}</span>
                </div>
              </div>
              <div class="service_prices">
                <div class="service_price lg1">{{ service.msr_value }}</div>
              </div>
            </div>
          </div>
          <div id="services_right">
            <div class="service" v-for="(service, index) in ratesLg[currentLg].otherServices.right" v-if="ratesLg[currentLg].settings.additional_services === '1' ? index < 3 : index < 4">
              <div class="services_labels">
                <div class="service_label lg1">
                  <span>{{ service.label_value }}</span> <span>{{ service.sub_label }}</span>
                </div>
              </div>
              <div class="service_prices">
                <div class="service_price lg1">{{ service.msr_value }}</div>
              </div>
            </div>
            <div class="service" v-if="ratesLg[currentLg].settings.additional_services === '1'">
              <div class="services_labels">
                <div class="service_label lg1" style="overflow: visible; white-space: nowrap">
                  <span>{{ ratesLg[currentLg].rates_new_additional_services }}</span> <span>{{ ratesLg[currentLg].rates_new_additional_services_subtitle }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="subtitles">
          <span>{{ratesLg[currentLg].settings.roomRate_footer}}</span>
          <span>{{ratesLg[currentLg].settings.serviceRate_footer}}</span>
      </div>
      <div id="site_name">
        {{ siteName }}
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header'
import Rates from './rates/rates'
import Services from './services/services'
import OverwatchLoader from '../../../../loader/overwatch'
import Change from './right/change/change'
import Hosts from './right/hosts/hosts'
import Messages from './right/messages/messages'
import model from '../../../../debug/model'
import moment from 'moment'

export default {
  name: 'IbisRatesHorizontalV2',
  components: {
    pageHead: Header,
    rates: Rates,
    services: Services,
    change: Change,
    hosts: Hosts,
    messages: Messages,
    OverwatchLoader,
    model
  },
  data: function () {
    return {
      rightOrder: ['change', 'hosts', 'messages'],
      model: ['A.jpg', 'B.jpg', 'C.jpg'],
      rightIndex: -1,
      msgCurrentPage: 1,
      goNextComponent: true,
      currentLg: 'lg1',
      lgTimeout: null,
      date: ''
    }
  },
  mounted () {
    this.$dm.getData(this.$route) // get data on start
    this.refreshDate()
    if (this.alternTimeout) {
      clearTimeout(this.alternTimeout)
    }
    this.alternTimeout = setTimeout(this.alternates, 7000)
  },
  computed: {
    ratesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id],
            lg2: data.languages[1] && data[data.languages[1].id]
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    netStatus () {
      return this.$store.state.connected
    },
    site () {
      let site = this.$store.getters.site
      return site
    },
    user () {
      return this.$store.getters.user
    },
    device () {
      return this.$store.getters.device
    },
    siteName () {
      try {
        return `ibis ${this.site.get('rates').get('data').siteName}`
      } catch (e) {
        return ''
      }
    },
    page () {
      return this.$route.query.page
    },
    transitionName () {
      if (this.page) {
        return 'off' // no transition if page is forced
      } else {
        return 'fade'
      }
    }
  },
  watch: {
    netStatus (newStatus, oldStatus) {
      console.log('netStatus update', oldStatus, newStatus)
      // Get data on connection status change
      if (oldStatus) { // getData must not be done the first time
        console.log('netStatus getdata')
        this.$dm.getData(this.$route)
      }
    },
    user (newUser, oldUser) {
      console.log('User update', oldUser, newUser)
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log('user getdata')
        this.$dm.getData(this.$route)
      }
    },
    device (newDevice, oldDevice) {
      console.log('Device update', oldDevice, newDevice)
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log('device getdata')
        this.$dm.getData(this.$route)
      }
    },
    site (newSite, oldSite) {
      console.log('Site updated', oldSite, newSite)
    }
  },
  methods: {
    alternates () {
      if (this.ratesLg && this.ratesLg.lg2) {
        if (this.currentLg === 'lg2') {
          this.currentLg = 'lg1'
        } else {
          this.currentLg = 'lg2'
        }
        if (this.lgTimeout) {
          clearTimeout(this.lgTimeout)
        }
        this.lgTimeout = setTimeout(this.alternates, 7000)
      }
    },
    refreshDate () {
      moment.locale('fr')
      this.date = moment().format('L - LT')
      setTimeout(this.refreshDate, 60000)
    },
    replaceBr (str) {
      return str.replace('<br>', ' ')
    }
  }
}
</script>

<style lang='less' scoped>
/*
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_ibis.scss";
 */
@import "ibisrouge2020.less";
@import "functions.less";


#ibisRatesHorizontalV2 {
  @srcWidth : 1920;
  @srcHeight : 1080;

  --color: #E20026;

  background-color: var(--color);
  color: white;

  .dimensions(160vh, 100vh);

  font-family: 'Vibis_text-Regular';

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .lg2 {
    font-family: 'Vibis_text-Lightitalic';
  }

  &.monolingue {
    #rates .lg2, #services .lg2 {
      display: none;
    }

    #main_title .lg2 {
      visibility: hidden;
    }
  }

  #main_title {
    padding-top: 16 * 100vh / @srcHeight;
    text-align: center;

    .lg1 {
      .font('Vibis_text-Black', 45, 1.2em);
    }

    #dot_separator {
      padding-top: 10 * 100vh / @srcHeight;
      padding-bottom: 15 * 100vh / @srcHeight;
      .font('Vibis_text-Regular', 27, 1.2em);
      letter-spacing: 0.2em;
    }

    #date_hour {
      font-size: 25 * 160vh / @srcWidth;
    }
  }

  #center {
    width: 100%;
    .heightPercent(750);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    #rates {
      .widthPercent(1820);

      #header_row {
        display: flex;
        justify-content: space-between;
        padding-bottom: 8 * 100vh / @srcHeight;
        border-bottom: 2* 100vh / @srcHeight solid white;

        #rates_title {
          font-size: 20 * 160vh / @srcWidth;

          span + span:not(:empty)::before {
            content: '/';
          }
        }

        #date_hour {
          font-family: 'Vibis_text-Light';
          font-size: 24 * 160vh / @srcWidth;
        }

        #rates_prices_titles {
          display: flex;
          justify-content: flex-end;
          font-size: 20 * 160vh / @srcWidth;
          //padding-top: 10 * 100vh / @srcHeight;

          span + span:not(:empty)::before {
            content: '/';
          }
        }
      }

      .col_price {
        text-align: center;
        .widthPercent(375);
        .heightPercent(26);
      }


      .rates_row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 2px solid white;
        padding-top: 5 * 100vh / @srcHeight;
        .heightPercent(100);

        .rates_labels {
          display: flex;
          flex-direction: column;

          .rate_label {
            .widthPercent(1065);
            font-size: 41 * 160vh / @srcWidth;
          }
        }

        .rates_prices {
          display: flex;

          .rate_price {
            display: flex;
            justify-content: center;
            align-items: center;
            .widthPercent(380);
            .heightPercent(72);
            font-family: 'Vibis_text-Black';
            font-size: 54 * 160vh / @srcWidth;

            .euro {
              font-family: 'Vibis_text-Light';
            }
          }
        }
      }
    }

    #services {
      padding-top: 30 * 100vh / @srcHeight;
      .widthPercent(1820);
      max-height: 405 * 100vh / @srcHeight;
      display: flex;

      #services_regular, #services_right {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      #services_regular {
        padding-right: 20 * 160vh / @srcWidth;
      }

      #services_right {
        padding-left: 20 * 160vh / @srcWidth;
      }

      .service {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .widthPercent(885);
        .heightPercent(82);

        .services_labels {
          .service_label {
            .widthPercent(680);
            .heightPercent(52);

            span:nth-of-type(1) {
              font-size: 41 * 160vh / @srcWidth;
            }

            span:nth-of-type(2) {
              font-size: 21 * 160vh / @srcWidth;
              padding-left: 8 * 160vh / @srcWidth;
            }
          }
        }

        .service_prices {
          display: flex;
          flex-direction: column;
          justify-content: center;

          .service_price {
            text-align: right;

            &:nth-of-type(1) {
              .widthPercent(200);
              .heightPercent(40);
              font-size: 41 * 160vh / @srcWidth;
            }

            &:nth-of-type(2) {
              .widthPercent(200);
              .heightPercent(26);
              font-size: 20 * 160vh / @srcWidth;
            }
          }
        }
      }
    }
  }

  #subtitles {
    .widthPercent(1504);
    padding-top: 23 * 100vh / @srcHeight;
    font-size: 17 * 160vh / @srcWidth;
    text-align: center;

    span + span {
      &:before {
        content: ' - ';
      }
    }
  }

  #site_name {
    position: absolute;
    bottom: 15 * 100vh / @srcHeight;
    left: 0px;
    width: 100%;
    text-align: center;
    .font('Vibis_text-Light', 37, 1.2em);
  }
}

</style>

<style lang='scss'>
@import "../../../_ibis.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;
}

#ibisRatesHorizontalV2 .lg1 {
  color: white!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v2/ibisRatesHorizontalV2.vue